import React, { FC } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { Wrapper } from "./styled";

const ModalError: FC<{ onClose: () => void; open: boolean }> = ({
  onClose,
  open,
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Wrapper onClose={handleClose} open={open}>
      <DialogTitle>Вы можете выбрать не более пяти сотрудников!</DialogTitle>
      <DialogActions>
        <Button onClick={handleClose} startIcon={<CloseIcon />} />
      </DialogActions>
    </Wrapper>
  );
};

export default ModalError;
